import { FC, ReactNode } from 'react'

import {
    Auth,
    Header,
    Loader,
    Notification,
    Sidebar,
    Sideover,
    Confirmation
} from '@/ui/views'

const Layout: FC<LayoutComponentProps> = (props): ReactNode => {
    const { children } = props

    return (
        <main className='bg-[#1E1E1E] w-full h-screen flex flex-col relative ignore-blur overflow-hidden'>
            <Loader />
            <Auth />
            <Header />
            <Sideover />
            <Notification />
            <Confirmation />

            <div className='w-full h-full flex relative ignore-blur'>
                <Sidebar />

                <div className='w-full h-full p-2 relative ignore-blur'>
                    {children}
                </div>
            </div>
        </main>
    )
}

export default Layout
